/**
 * Guideable Directive
 * Mark elements as targets for guidance (helps with selector stability)
 */

import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[guideable]',
  standalone: true
})
export class GuideableDirective implements OnInit {
  @Input('guideable') guideId: string = '';
  @Input() guideDescription: string = '';

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    // Set data attribute for easy selection
    if (this.guideId) {
      this.el.nativeElement.setAttribute('data-guide', this.guideId);
    }

    // Set description attribute if provided
    if (this.guideDescription) {
      this.el.nativeElement.setAttribute('data-guide-desc', this.guideDescription);
    }

    // Add a class for styling purposes
    this.el.nativeElement.classList.add('guideable-element');
  }
}
